export default __webpack_public_path__ + "static/media/18.8840ce34.jpg";